module.exports = __webpack_public_path__ + "img/totmatonoodle1.8cfc7291.png";